import { useState, useEffect } from "react";
import { MQTTI } from '../../helper/mqttClient';
import { Buffer } from 'buffer';
import { Grid, Paper, Box, Container, CircularProgress } from "@mui/material";
import { experimentalStyled as styled } from '@mui/material/styles';
import { CarPD } from "./CardPD";

function PowerDistribution({ topic }) {
    const metaTopic = topic.split("/")
    const ipcSerialNumber = metaTopic[1]
    const pduId = metaTopic[2]
    const [isLoad, setIsLoad] = useState(false)
    const [pduProps, setPduProps] = useState({
        temp: 0,
        vRtu: 0,
        vIpc: 0,
        vRouter: 0,
        vCam: 0,
        vPd: 0,
        rssi: 0
    })
    const pduArray = [
        {
            key: "Arus",
            value: pduProps.temp
        },
        {
            key: "Volt Rtu",
            value: pduProps.vRtu
        },
        {
            key: "Volt Ipc",
            value: pduProps.vIpc
        },
        {
            key: "Volt Router",
            value: pduProps.vRouter
        },
        {
            key: "Volt Cam",
            value: pduProps.vCam
        },
        {
            key: "Volt PDU",
            value: pduProps.vPd
        },
        {
            key: "RSSI",
            value: pduProps.rssi
        }
    ]
    const onClickSendMqtt = (title, cmd) => {
        setIsLoad(true)

        const publishTopic = ["JembatankuMaster", "request/post/powerCommand", ipcSerialNumber]
        console.log(`topic: ${publishTopic.join("/")} ; msg: ${pduId},${title}${cmd}`)
        MQTTI().publish(publishTopic.join("/"), `${pduId},${title}${cmd}`)
        // delay 5 detik
        setTimeout(() => {
            setIsLoad(false)
        }, 4200)
    }

    useEffect(() => {
        const instance = MQTTI().subscribe(topic)
        console.log("Subscribe", topic);
        instance.on("message", (topic, message) => {
            const payload = { topic, message: message.toString() }
            // console.log("Payload", payload)
            const metaPayload = payload.message.split(",");
            const buffer = metaPayload[1];
            const tempVal = []

            for (let i = 0; i < buffer.length; i += 6) {
                const stringPackx = buffer.slice(i, i + 6);
                const floatValuex = Buffer.from(stringPackx + "==", "base64").readFloatLE(0);
                tempVal.push(floatValuex)
            }

            // console.log(tempVal)
            setPduProps(oldData => ({
                ...oldData,
                temp: tempVal[0],
                vRtu: tempVal[1],
                vIpc: tempVal[2],
                vRouter: tempVal[4],
                vCam: tempVal[3],
                vPd: tempVal[5],
                rssi: tempVal[6]
            }))

        })
    }, [])
    return (
        <>
            <Box sx={{ justifyContent: "center", textAlign: "center"}}>
                {isLoad && (<CircularProgress />)}
            </Box>
            <Box component="main" sx={{ flexGrow: 1, marginTop: 2 }}>
                <Container maxWidth={false}>
                    <Grid container spacing={{ xs: 2, md: 3 }}>
                        {pduArray.map((item, index) => (
                            <Grid item lg={3} sm={6} xl={3} xs={12} key={index}>
                                <CarPD handleClick={() => onClickSendMqtt()} title={item.key} value={Math.ceil(item.value * 100) / 100} isLoad={isLoad} />
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>
        </>
    )
}

export {PowerDistribution};